module.exports = __webpack_public_path__ + "img/sort-descending.86acc0cf.svg";